import React from 'react';
import { useLanguage } from './LanguageContext';
import { Globe } from 'lucide-react';

const LanguageToggle = ({ currentBranch }) => {
  const { currentLanguage, updateBranchLanguage } = useLanguage();

  const handleLanguageChange = (e) => {
    const newLanguage = e.target.value;
    if (currentBranch?.branch_id) {
      updateBranchLanguage(currentBranch.branch_id, newLanguage);
    }
  };

  return (
    <div className="flex items-center gap-2">
      <Globe size={18} className="text-gray-500" />
      <select
        value={currentLanguage}
        onChange={handleLanguageChange}
        className="text-sm border rounded px-2 py-1 bg-white"
      >
        <option value="th">ไทย</option>
        <option value="en">English</option>
      </select>
    </div>
  );
};

export default LanguageToggle;
